// scoringOptions.js - Delade etiketter för poängmetoder (speglar backend/form_scoring.py)

export const SCORING_METHOD_LABELS = {
  none: 'Ingen poängberäkning',
  sum: 'Summa',
  mean: 'Medelvärde',
  percent_of_max: 'Procent av max',
  eq5d: 'EQ-5D (profil + VAS)',
};

export const QUESTION_TYPE_LABELS = {
  single_choice: 'Envalsfråga',
  scale: 'Skala (tal)',
  text: 'Fritext',
};

/** Kan frågan ingå i poängberäkning? (numeriska alternativ eller skala) */
export function isScorable(q) {
  if (q.type === 'scale') return q.min !== '' && q.max !== '' && q.min !== undefined && q.max !== undefined;
  if (q.type === 'single_choice') {
    return (q.options || []).some(o => o.value !== '' && Number.isFinite(Number(o.value)));
  }
  return false;
}
